import CONTENT_HEADER from "../plugins/content_header"
// import '../plugins/googlemap'
// import GOOGLEMAP from '../plugins/googlemap_disp'

export default function FEATURES() {

  // GOOGLEMAP() // Googlemap実行パート
  
  $(() => {
    CONTENT_HEADER()
  })
}